export default "__VITE_ASSET__BTk7Fpyw__"